import { render, staticRenderFns } from "./imgModal.vue?vue&type=template&id=4229a153&scoped=true&"
import script from "./imgModal.vue?vue&type=script&lang=ts&"
export * from "./imgModal.vue?vue&type=script&lang=ts&"
import style0 from "./imgModal.vue?vue&type=style&index=0&id=4229a153&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4229a153",
  null
  
)

export default component.exports